import update from 'immutability-helper'
import { useGqlExamRestoredQuestionKeywordsQuery } from 'generated/graphql'
import useIntersect from '@app.modules/hooks/useIntersect'

interface ParameterType {
  questionId: string
  cursor?: string
}

const useGetQuestionKeywords = ({ questionId }: ParameterType) => {
  const { data, fetchMore } = useGqlExamRestoredQuestionKeywordsQuery({
    variables: {
      cursorPagination: { take: 50 },
      questionId,
    },
  })

  const handleIntersect = () => {
    fetchMore({
      variables: {
        cursorPagination: {
          take: 50,
          cursor: data?.examRestoredQuestionKeywords.pageInfo.endCursor,
        },
        questionId,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult || !fetchMoreResult.examRestoredQuestionKeywords) {
          return prev
        }

        const result = update(prev, {
          examRestoredQuestionKeywords: {
            nodes: {
              $push: fetchMoreResult.examRestoredQuestionKeywords.nodes,
            },

            pageInfo: {
              $set: fetchMoreResult.examRestoredQuestionKeywords.pageInfo,
            },
            totalCount: {
              $set: fetchMoreResult.examRestoredQuestionKeywords.totalCount,
            },
          },
        })
        return result
      },
    })
  }

  const ref = useIntersect(handleIntersect, [data ?? {}])

  return { keywords: data?.examRestoredQuestionKeywords, ref }
}

export default useGetQuestionKeywords
